import { render, staticRenderFns } from "./author-password.vue?vue&type=template&id=bf30cffe&"
import script from "./author-password.vue?vue&type=script&lang=js&"
export * from "./author-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports